import { Container } from '@plone/components';
import Logo from '@plone/volto/components/theme/Logo/Logo';
import { useLiveData } from '@kitconcept/volto-light-theme/helpers/useLiveData';
import ColumnLinks from '@kitconcept/volto-light-theme/components/Footer/ColumnLinks';
import type { SiteFooterSettings } from '@kitconcept/volto-light-theme/types';
import type { Content } from '@plone/types';
import SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';

const PostFooter = ({
  content,
  location,
}: {
  content: Content;
  location?: any;
}) => {
  const footer_address = useLiveData<SiteFooterSettings['footer_address']>(
    content,
    'kitconcept.footer',
    'footer_address',
  );

  const footer_column_left_header = useLiveData<
    SiteFooterSettings['footer_column_left_header']
  >(content, 'kitconcept.footer', 'footer_column_left_header');
  const footer_column_left = useLiveData<
    SiteFooterSettings['footer_column_left']
  >(content, 'kitconcept.footer', 'footer_column_left');

  const footer_column_middle_header = useLiveData<
    SiteFooterSettings['footer_column_middle_header']
  >(content, 'kitconcept.footer', 'footer_column_middle_header');
  const footer_column_middle = useLiveData<
    SiteFooterSettings['footer_column_middle']
  >(content, 'kitconcept.footer', 'footer_column_middle');

  const footer_column_right_header = useLiveData<
    SiteFooterSettings['footer_column_right_header']
  >(content, 'kitconcept.footer', 'footer_column_right_header');
  const footer_column_right = useLiveData<
    SiteFooterSettings['footer_column_right']
  >(content, 'kitconcept.footer', 'footer_column_right');

  return (
    <Container className="footer-post-footer-container">
      <div className="navigation-row">
        <div className="column-brand">
          <div className="brand-logo">
            {/* @ts-ignore the Logo definition is different from the Volto one */}
            <Logo isFooterLogo />
          </div>
          <div className="brand-info">
            <p className="brand-slogan">Como chegar</p>
            {footer_address ? (
              <p
                className="brand-description"
                style={{ whiteSpace: 'pre-line' }}
                dangerouslySetInnerHTML={{
                  __html: footer_address,
                }}
              />
            ) : (
              <p className="brand-description">
                Daqui ficará o texto para o rodapé do site, com as informações
                necessárias para os usuários.
              </p>
            )}
            <SlotRenderer
              name="followUs"
              content={content}
              location={location}
            />
          </div>
        </div>

        <div className="footer-grid footer-doormat">
          {footer_column_left && footer_column_left.length > 0 && (
            <div className="footer-doormat-section">
              <div className="footer-doormat-section-content">
                {footer_column_left_header && (
                  <h2>
                    <strong>{footer_column_left_header}</strong>
                  </h2>
                )}
                <ColumnLinks links={footer_column_left} />
              </div>
            </div>
          )}

          {footer_column_middle && footer_column_middle.length > 0 && (
            <div className="footer-doormat-section">
              <div className="footer-doormat-section-content">
                {footer_column_middle_header && (
                  <h2>
                    <strong>{footer_column_middle_header}</strong>
                  </h2>
                )}
                <ColumnLinks links={footer_column_middle} />
              </div>
            </div>
          )}

          {footer_column_right && footer_column_right.length > 0 && (
            <div className="footer-doormat-section">
              <div className="footer-doormat-section-content">
                {footer_column_right_header && (
                  <h2>
                    <strong>{footer_column_right_header}</strong>
                  </h2>
                )}
                <ColumnLinks links={footer_column_right} />
              </div>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

export default PostFooter;
